<div id="dashboardFilterContainer">
    <div class="slidedown">
        <div *ngIf="initialized" class="filterContainer">
            <sol-query-builder class="queryBuilder"
                [filters]="[filterCampaigns, filterSkills, filterPOCs, filterTeams, filterAgents, filterDateParadigm, filterOnTheFlyEvals, filterForms, filterGroups]"
                [model]="selectedFilters" [showErrorMessage]="showErrorMessage"
                (selectionChanged)="onSelectionChange($event)" [addFilterText]="'Add Filter'">
            </sol-query-builder>
            <sol-button class="applyButton"
                [variant]="'primary'" 
                (onClick)="applyFilter()"
                [size]="'large'"
                [disabled]="!applyButtonEnabled">
                <span cvLocalizedText langSection="Dashboard_Filter" langKey="Apply">Apply</span>
            </sol-button>
        </div>
    </div>
